import tw from "twin.macro"
import styled from "@emotion/styled/macro"
import { css } from "@emotion/react/macro"

import { StyledLink } from "../../../Styled/Button"
import { StyledColumn } from "../../../Styled/Column"
import { StyledRow } from "../../../Styled/Row"
import { H3, H5 } from "../../../Styled/Text"

const colours = {
  learn: tw`border-teal`,
  navigator: tw`border-purple`,
  providers: tw`border-pink`,
}

const offsets = [tw`delay-100`, tw`delay-200`, tw`delay-300`]

export const Content = tw.div`relative md:flex md:items-stretch md:justify-between bg-white rounded-xl shadow-lg overflow-hidden`
export const ContentBlock = styled(Content)`
  ${tw`transition-all duration-200 relative w-full h-full flex-col items-stretch px-5 lg:px-7.5 py-6 lg:py-9.5 overflow-hidden text-left transform md:hover:scale-105 hover:shadow-xl outline-none focus:outline-none`}
`
export const ContentBlockBorder = styled.div`
  ${tw`w-full absolute inset-x-0 bottom-0 border-b-8 border-white`}
  ${({ colour }) => colour && colours[colour] && colours[colour]}
`
export const ContentStack = styled.div`
  ${tw`relative flex flex-col items-stretch justify-center -mt-34 pb-24`}
  ${({ height }) =>
    height &&
    css`
      @media (max-width: 768px) {
        max-height: ${height + 48}px;
      }
    `}
`
export const ContentStackRow = tw(StyledRow)`-my-3 md:my-0 md:-mx-3`
export const ContentStackColumn = styled(StyledColumn)`
  ${tw`py-3 md:py-0 md:px-3 transition-all duration-500 opacity-0 invisible transform translate-y-16`}
  ${({ animated }) => animated && tw`opacity-100 visible translate-y-0`}
  ${({ offset }) => offsets[offset]}
`
export const ContentStackItem = styled.div`
  ${tw`absolute inset-0 opacity-0 invisible pointer-events-none transform translate-x-16 first:relative first:-translate-x-16 transition-all duration-200`}
  ${({ active }) => active && tw`opacity-100 visible translate-x-0 first:translate-x-0 pointer-events-auto`}
`
export const ContentSection = styled.div`
  ${tw`relative md:flex md:flex-col md:items-start md:justify-between w-full md:w-1/2 max-w-full py-6.5 md:py-13 px-5 md:px-12`}
  ${({ bg }) => bg === `dark` && tw`bg-grey-lightest`}
`
export const ContentTitle = tw(H5)`transition-colors duration-200 text-navy group-hover:text-orange`
export const ContentHeading = tw(H3)``
export const ContentIcon = tw.div`flex-shrink-0`
export const ContentText = tw.div`md:flex md:flex-col md:items-start md:justify-between flex-1 pl-6 max-w-100`
export const ContentRow = tw(StyledRow)`w-full h-full`
export const ContentLinks = tw.div`w-full mb-12`
export const ContentLink = styled(StyledLink)`
  ${tw`w-full flex items-center justify-between font-normal hover:font-bold hover:text-teal text-base border-b border-grey-border last:border-0 py-3 leading-tight`}
  span {
    ${tw`mr-2`}
  }
`
export const ContentButton = styled(StyledLink)`
  ${tw`flex items-center justify-between font-normal hover:text-teal`}
  span {
    ${tw`ml-2`}
  }
`
export const ContentHelpButton = styled(StyledLink)`
  ${tw`text-xms md:text-base text-navy font-bold border-b border-solid border-t-0 border-l-0 border-r-0 border-navy hover:border-teal pb-0 hover:text-teal focus:outline-none transition-colors duration-200`}
  ${({ spacing }) => spacing && tw`ml-3`}
`
